// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"0d9cb456","484":"d050e7eb","643":"0e02bb73","734":"a484f421","882":"c5466e6c"}[chunkId] + ".chunk.js";
};